



































import Vue from "vue"
import Datatable, {DatatableOptions, FilterContainer, IDatatable} from "@/components/datatable/Datatable.vue"
import {Address} from "@/model/entity/address/address"
import {addressService, IAddressService} from "@/model/service/address/address-service"
import {FieldDescription, FieldTypeEnum} from "@/model/entity/field-descriptor"
import {Filter} from "@/model/dto/filter"

interface Data {
  listAddressService: IAddressService
  options: DatatableOptions
  fields: FieldDescription[]
  filters: FilterContainer
}

export default Vue.extend({
  components: {
    Datatable
  },
  data(): Data {
    return {
      listAddressService: addressService,
      options: {
        operations: {
          edit: true,
          delete: true
        }
      },
      fields: Address.getFieldDescriptionList(),
      filters: []
    }
  },
  methods: {
    deleteAll() {
      const vm = this
      vm.$confirm(vm.$t("address_list.delete_all_message").toString(), vm.$t("general.warning").toString(), {
        confirmButtonText: "OK",
        cancelButtonText: vm.$t("general.cancel").toString(),
        type: "warning"
      }).then(() => {
        vm.listAddressService.deleteAll()
          .then(() => {
            (vm.$refs.datatable as IDatatable).refreshData()
          })
          .catch(error => vm.$error(error.message))
      })
    },
    handleFileResponse(response: any) {
      const filename = response.headers["content-disposition"].match(/attachment; filename=(.*)/)[1]
      const contentType = response.headers["content-type"]
      const blob = new Blob([response.data], { type: contentType })
      saveAs(blob, filename)
    },
    exportFile() {
      const vm = this
      vm.startLoad()
      const filters: Filter[] = []
      vm.fields
      .filter(field => exists(vm.filters[field.fieldName!]) && vm.filters[field.fieldName!].toString().length > 0)
      .forEach(field => {
        filters.push(new Filter(field.fieldName!, vm.filters[field.fieldName!]))
      })
      this.listAddressService
      .exportWithFilters(filters)
      .then((response: any) => {
        vm.endLoad()
        vm.handleFileResponse(response)
      })
      .catch(() => vm.endLoad())
    }
  }
})
